import React from "react";
import menu from '../../config/menu';
import MenuItem from './MenuItem';
import PropTypes from 'prop-types';

export default class MenuItems extends React.PureComponent {
    getLink = (link) => {
        const parts = document.location.href.split('?');

        if (parts.length === 2) {
            const params = parts[1].split('&');
            const gtmPreview = params.find(param => /^gtm_debug=/.test(param));

            if (gtmPreview) {
                const separator = link.includes('?') ? '&' : '?';
                link = `${link}${separator}${gtmPreview}`;
            }
        }

        return link;
    };

    render() {
        let { onClick, isLogged } = this.props;

        return (
            <div className={`menu-items${isLogged ? ' logged' : ''}`}>
                {menu.map((menuItem, index) => {
                    return <MenuItem
                        onClick={onClick}
                        link={this.getLink(menuItem.link)}
                        text={menuItem.text}
                        target={menuItem.target}
                        className={`top-link`}
                        key={index}/>
                })}

                {isLogged ? <MenuItem
                    onClick={onClick}
                    link={'/dashboard'}
                    text={'Dashboard'}
                    className={`top-link`}/> : false}
            </div>
        );
    }
}

MenuItem.propTypes = {
    onClick: PropTypes.func,
    isLogged: PropTypes.bool,
};
